import { FiFacebook, FiInstagram, FiMessageCircle } from 'react-icons/fi'
import { useNavigate } from 'react-router-dom'

import ContainerFooterCircular from './styles'
import useAppConfig from '../../../hooks/useAppConfig'
import BackgroundFooterOneSVG from '../../../assets/svgs/background-footer-one'
import { logFirebaseEvent } from '../../../services/firebase/analytics'

export default function FooterCircular() {
  const navigate = useNavigate()

  const { appConfig } = useAppConfig()

  const handleANalyticsButtonClick = (platform: string) => {
    logFirebaseEvent('social_click', {
      screen_name: 'landing_page',
      platform,
    })
  }

  const handleANalyticsButtonClick2 = (linkType: string) => {
    logFirebaseEvent('terms_click', {
      screen_name: 'landing_page',
      link_type: linkType,
    })

    window.scrollTo(0, 0)

    navigate('/politica-de-privacidade')
  }

  return (
    <ContainerFooterCircular
      color={
        appConfig?.appConfig?.styles?.forceSecondaryColor ? 'true' : undefined
      }
    >
      <div className="middle-section">
        <div className="position-background-absolute">
          <BackgroundFooterOneSVG />
        </div>
        <div className="m-s-top">
          <div className="m-s-t-left">
            <div className="content-image-logo-marca">
              <img
                src={appConfig?.appConfig?.appLogo}
                alt="Footer Logo"
                width="100%"
                height="auto"
              />
              <div className="logo-marca">KFamily</div>
            </div>
            <div className="description">
              {appConfig?.appConfig?.appDescription}
            </div>
            <div className="box-icon-contact">
              <div
                className="box-icon-contact-option"
                aria-hidden
                onClick={() => {
                  handleANalyticsButtonClick('facebook')
                }}
              >
                <FiFacebook />
              </div>
              <div
                className="box-icon-contact-option"
                aria-hidden
                onClick={() => {
                  handleANalyticsButtonClick('instagram')
                }}
              >
                <FiInstagram />
              </div>
              <div
                className="box-icon-contact-option"
                aria-hidden
                onClick={() => {
                  handleANalyticsButtonClick('whatsapp')
                }}
              >
                <FiMessageCircle />
              </div>
            </div>
          </div>
          <div className="m-s-t-right">&nbsp;</div>
        </div>
        <div className="m-s-bottom">
          <div className="m-s-t-left">
            © {appConfig?.appConfig?.footer?.rightsLabel}
          </div>
          <div className="m-s-t-right">
            <div
              className="link"
              aria-hidden
              onClick={() => {
                handleANalyticsButtonClick2('privacy_policy')
              }}
            >
              {appConfig?.appConfig?.footer?.privacyPolicy}
            </div>
          </div>
        </div>
      </div>
    </ContainerFooterCircular>
  )
}
